/**
 * Theme-aware Leaflet tile-URL helper.
 *
 * - When REACT_APP_MAPBOX_TOKEN is set (typically injected via GCP Secret Manager
 *   at build time), returns Mapbox styles:
 *     • dark   → mapbox/satellite-streets-v12
 *     • smooth → mapbox/light-v11
 * - Otherwise falls back to free providers (works without any key):
 *     • dark   → Esri World Imagery
 *     • smooth → Carto Voyager
 *
 * Used by both the public Landing Page and the authenticated Hub Dashboard
 * to keep the Mapbox style mapping single-source-of-truth.
 */
const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';

export const buildTileUrl = (mode) => {
  if (MAPBOX_TOKEN) {
    const styleId = mode === 'smooth' ? 'light-v11' : 'satellite-streets-v12';
    return `https://api.mapbox.com/styles/v1/mapbox/${styleId}/tiles/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`;
  }
  return mode === 'smooth'
    ? 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
    : 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
};

export const tileAttribution = (mode) =>
  MAPBOX_TOKEN
    ? '© Mapbox © OpenStreetMap'
    : (mode === 'smooth' ? '© Carto © OpenStreetMap' : 'Tiles © Esri');

export const HAS_MAPBOX_TOKEN = !!MAPBOX_TOKEN;
